import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_bedtime-story.scss';

const BedtimeStory2: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    try {
      const response = await fetch('/api/completed-sessions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          title: 'The Sleepy Treehouse',
          description: 'Completed Bedtime Story 2 session.',
          image: require('../assets/sleeping.png').default || require('../assets/sleeping.png'),
          duration: '10 min',
          type: 'bedtime-story'
        })
      });
      if (response.ok) {
        navigate(-1);
      } else {

        navigate(-1);
      }
    } catch (error) {

      navigate(-1);
    }
  };

  return (
    <div className={`bedtime-story-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="bedtime-story-container">
        <header className="bedtime-story-header">
          <a
            className="bedtime-story-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="material-symbols-outlined">arrow_back</span>
          </a>
          <div className="bedtime-story-header-content">
            <h1 className="bedtime-story-title">The Sleepy Treehouse</h1>
            <p className="bedtime-story-subtitle">A soothing bedtime story to help you drift into peaceful sleep</p>
          </div>
        </header>

        <main className="bedtime-story-main">
          <div className="bedtime-story-video-wrapper">
            <div className="bedtime-story-video-container">
              <iframe
                className="bedtime-story-video"
                src="https://www.youtube.com/embed/W8LlYqsc2-Y?autoplay=0&fs=1&playsinline=1"
                title="Bedtime Story 2: The Sleepy Treehouse"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="bedtime-story-content">
            <p className="bedtime-story-description">
              Climb the branches of a cozy treehouse nestled high among the stars. This gentle story weaves a tale of comfort and safety, perfect for easing into a restful night's sleep.
            </p>
            <button 
              className="bedtime-story-finish-btn" 
              onClick={handleFinish}
            >
              <span className="material-symbols-outlined">done</span>
              <span>Mark as Complete</span>
            </button>
          </div>
        </main>
      </div>
    </div>
  );
};

export default BedtimeStory2;

